import { Navigate, type RouteObject } from "react-router-dom";
import { PortalAuthProvider } from "@/lib/portalAuth";
import { page } from "@/app/page";
import { Branded, LoginRoute, PortalGuestRedirect, RequirePortalAuth, TwoFactorRoute } from "@/app/guards";

export const publicRoutes: RouteObject[] = [
  {
    element: <Branded brand="control" />,
    children: [
      { id: "auth.login", path: "/auth/login", element: <LoginRoute /> },
      { id: "auth.2fa", path: "/auth/2fa", element: <TwoFactorRoute /> },
      { id: "careers.list", path: "/careers/:tenantSlug", element: page(() => import("@/screens/careers/Careers")) },
      { id: "careers.detail", path: "/careers/:tenantSlug/:slug", element: page(() => import("@/screens/careers/CareerDetail")) },
    ],
  },
  {
    element: <Branded brand="legionella" />,
    children: [{ id: "get-app", path: "/get-app", element: page(() => import("@/screens/legionella/GetApp")) }],
  },
  {
    // The tracker app hosted trip shares and the customer portal; they keep its brand and portal login.
    element: <PortalAuthProvider><Branded brand="tracker" /></PortalAuthProvider>,
    children: [
      { id: "share.trip", path: "/share/:token", element: page(() => import("@/screens/vehicles/TripShare")) },
      { id: "share.live", path: "/share/live/:token", element: page(() => import("@/screens/vehicles/TripShareLive")) },
      { id: "portal.forgot", path: "/portal/forgot", element: <PortalGuestRedirect>{page(() => import("@/screens/portal/PortalForgot"))}</PortalGuestRedirect> },
      { id: "portal.setup", path: "/portal/setup", element: page(() => import("@/screens/portal/PortalSetup")) },
      { id: "portal.reset", path: "/portal/reset", element: page(() => import("@/screens/portal/PortalSetup")) },
      { id: "portal.login", path: "/portal/login", element: <Navigate to="/auth/login" replace /> },
      {
        id: "portal",
        path: "/portal",
        element: <RequirePortalAuth>{page(() => import("@/screens/portal/PortalLayout"))}</RequirePortalAuth>,
        children: [
          { id: "portal.overview", index: true, element: page(() => import("@/screens/portal/PortalOverview")) },
          { id: "portal.site", path: "sites/:id", element: page(() => import("@/screens/portal/PortalSite")) },
          { id: "portal.asset", path: "assets/:id", element: page(() => import("@/screens/portal/PortalAsset")) },
          { id: "portal.history", path: "history", element: page(() => import("@/screens/portal/PortalHistory")) },
          { id: "portal.work-order", path: "work-orders/:id", element: page(() => import("@/screens/portal/PortalWorkOrder")) },
          { id: "portal.issues", path: "issues", element: page(() => import("@/screens/portal/PortalIssues")) },
          { id: "portal.issue", path: "issues/:id", element: page(() => import("@/screens/portal/PortalIssue")) },
          { id: "portal.documents", path: "documents", element: page(() => import("@/screens/portal/PortalDocuments")) },
          { id: "portal.account", path: "account", element: page(() => import("@/screens/portal/PortalAccount")) },
        ],
      },
    ],
  },
];
